export const updateObject = (oldObject, changedProperties) => {
  return {
    ...oldObject,
    ...changedProperties
  }
}

export const validateForm = (formData) => {
  let formIsValid = true;

  for (let formItem in formData) {
    formIsValid = formData[formItem].valid && formIsValid;
  }

  return formIsValid;
}


// WEBPACK FOOTER //
// ./src/shared/utilities.js